export const useStream = () => {
  const getStreamName = (nodeId: string, deviceId: string) => {
    if (!nodeId || !deviceId) return "";

    let device = deviceId;

    if (!deviceId.includes("DE")) {
      device = "DE_" + deviceId;
    }

    const streamName = (nodeId + "_" + device).replace(/[^a-zA-Z0-9_.-]/g, "_");

    return streamName;
  };

  return { getStreamName };
};
